export default __webpack_public_path__ + "static/lion1-cc6a0687ce1e047e2c42e52a77f6d254.png";